module.exports = __webpack_public_path__ + "static/media/11NEPAD10.8ad19c4e.jpg";